<template>
  <div v-if="type==='default'" :class="barClass" :style="{
    'height': height,
    'width': percent+'%',
    'display': 'block'
  }"></div>
  <div v-else class="e-progress-bar">
    <div :class="barClass" :style="{
    'height': height,
    'width': '100%',
    'display': percent > 0 ? 'block' : 'none'
  }">
      <div class="progressbar bar bar1" style="width: 0%;"></div>
      <div class="bufferbar bar bar2" style="width: 100%;"></div>
      <div class="auxbar bar bar3" style="width: 0%;"></div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'e-progress-bar',
    data () {
      // used for preventing hide on first pwa load
      this._lockAppBootsrap = true

      // used for preventing hide on pallel data fetch
      this._hideAppBootsrapLoader = false

      return {
        percent: 0,
        show: false,
        canSuccess: true,
        height: '5px',
        speed: 15
      }
    },
    props: {
      type: {
        type: String,
        default: 'material'
      }
    },
    computed: {
      barClass () {
        if (this.type === 'default') {
          if (this.canSuccess) {
            return 'e-progress-bar'
          } else {
            return 'e-progress-bar fail'
          }
        }
        if (this.canSuccess) {
          return 'mdl-progress mdl-js-progress mdl-progress__indeterminate'
        }
        return 'mdl-progress mdl-js-progress mdl-progress__indeterminate fail'
      }
    },
    methods: {
      start () {
        this.show = true
        this.canSuccess = true
        if (this._timer) {
          clearInterval(this._timer)
          this.percent = 0
        }
        if (this._hideAppBootsrapLoader) {
          this._hideAppBootsrapLoader = false
        }
        this._timer = setInterval(() => {
          this.increase(this.speed * Math.random())
          if (this.percent > 95) {
            // infinity progress bar
            this.percent = 5
            // this.finish()
          }
        }, 100)
        return this
      },
      startOrContinue () {
        if (!this.show) {
          return this.start()
        } else {
          return this
        }
      },
      set (num) {
        this.show = true
        this.canSuccess = true
        this.percent = Math.floor(num)
        return this
      },
      get () {
        return Math.floor(this.percent)
      },
      increase (num) {
        this.percent = this.percent + Math.floor(num)
        if (this.percent < 5) {
          this.percent = 5
        }
        return this
      },
      decrease (num) {
        this.percent = this.percent - Math.floor(num)
        return this
      },
      finish () {
        this.percent = 100
        this._hideAppBootsrapLoader = true
        this.hide()
        return this
      },
      pause () {
        clearInterval(this._timer)
        return this
      },
      unLockAppBootstrap () {
        this._lockAppBootsrap = false
        if (this.show === false) {
          this.finish()
        }
      },
      hideAppBootsrap () {
        if (this._lockAppBootsrap) {
          return
        }
        if (!this._hideAppBootsrapLoader) {
          return
        }
        if (document.getElementById('app-bootstrap')) {
          document.getElementById('app-bootstrap').style.display = 'none'
        }
      },
      showAppBootsrap () {
        if (document.getElementById('app-bootstrap')) {
          document.getElementById('app-bootstrap').style.display = 'block'
        }
      },
      hide () {
        clearInterval(this._timer)
        this._timer = null
        setTimeout(() => {
          Vue.nextTick(() => {
            setTimeout(() => {
              this.percent = 0
              this.hideAppBootsrap()
              this.show = false
            }, 80)
          })
        }, 100)
        return this
      },
      fail () {
        this.canSuccess = false
        return this
      }
    }
  }
</script>
